<h4> YOUR PAYMENT IS BEING PROCESSED </h4>
<p>
	In a few minutes you will receive a confirmation email to the previously given address, specifying whether it has
	been accepted or rejected.
</p>

<p>
	Please use the navigation bars to exit from this page.
</p>